import React, { useRef, useState,  useEffect } from "react"

import Box from "@/components/ui/box"
import AnimatedLetters from "@/animations/AnimatedLetters"
import AnimatedBody from "@/animations/AnimatedBody"
import { Ivy } from "@/fonts/spaceGrotesk"
import ConstParticles from "@/components/other/consparticles"
import { Consellations } from "@/server/constellations"

const SmoothScroll = ({certificate } : any ) => {

    const mainRef = useRef<any>(null)
    const [isVisible, setIsVisible] = useState('hidden')
  const [loading, setLoading] = useState(true)
  const [constellationsArray, setConstellationsArray] = useState<any>([])
useEffect(() => {
    
    async function getData() {
      
        const constellations = await fetch(`${process.env.NEXT_PUBLIC_URL}/api/cons?certificate=${certificate}`);
        const constellations2 = await constellations.json();
        const newcons = constellations2['visible'];
        setLoading(false)
        const constellationsArray : any = Object.entries(Consellations).map(([name, details]) => ({
            name,
            ...details,
            visible : newcons.includes(name)
          }));
            setConstellationsArray(constellationsArray)
    }
    getData();
}
, [])

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries : any ) => {
        if (entries[0].isIntersecting) {
          setIsVisible('visible');
        } else {
        }
      },
      {
        threshold: 0.1 // Adjust this value based on how much of the element should be visible before triggering
      }
    );

    if (mainRef.current) {
      observer.observe(mainRef.current);
    }

    return () => {
        if (mainRef.current) {
          observer.unobserve(mainRef.current);
        }
      };
    }, [mainRef]);

  return (
    <>

    <ConstParticles show={isVisible} />
   <div className=" h-[150vh] sm:h-[100vh] z-50 w-screen !max-w-screen flex items-center flex-col sm:flex-row gap-2 !overflow-hidden 
       " ref={mainRef} >
        {!loading && (    <>
   <div className="flex flex-col ms-2.5 justify-center items-center ">
<AnimatedLetters style={`font-black items-center justify-center text-center font-normal !max-w-[100%] !w-[100%] leading-[1] text-[3rem] sm:text-[4rem] flex flex-col text-center m-0 ${Ivy.className}`}
                    title={`Yıldızların Aileleri`} />
   <AnimatedBody underline={true} underlineColor="#942828" delay={0.2} className="text-[3rem]  w-min  leading-none !text-[#fff] sm:text-[4rem] font-black text-center m-0"
                    text={`Takımyıldızları`} />

<AnimatedBody delay={0.2}
                    className="text-xl my-3 max-w-[90%] sm:max-w-[70%] sm:text-xl font-normal text-center !text-opacity-100 !text-white-vibrant "
                    text={`Takımyıldızlarına, "Yıldız aileleri" desek yanlış olmaz. Onlar adeta milyonlarca yıldızdan oluşan çekirdek aileler. Gece gökyüzüne baktığımızda ortalama bir günde 25-30 civarında takımyıldızını görebiliriz. Elbette bu konuma ve zamana göre oldukça değişken olabilir. Sizin konum ve tarihinize göre gökyüzünde gözüken takımyıldızlarını sarı renkle işaretledik.

                    `} /></div>
     
          <div className=" flex flex-row  justify-start !w-full sm:!w-screen  !overflow-scroll  ">
      
    


{constellationsArray.map(({ name, desc, image, visible } : any ) => (
  <Box key={name} title={name} desc={desc} visible={visible} icon={image} />
))}

</div>  </>)}
      </div>     

    </>
  )
}

export default SmoothScroll
